interface TitleFilenameItem extends Record<string, unknown> {
    title: Maybe<string>;
    filename: Maybe<string>;
}

export const getTitleFilenameSortKey = ({
    title,
    filename,
}: TitleFilenameItem): string => {
    if (title && filename) {
        return `${title} ${filename}`;
    }

    if (title) {
        return title;
    }

    if (filename) {
        return filename;
    }

    return '';
};
